import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b55e764e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["tabindex"]
const _hoisted_2 = { class: "max-w-[595px] px-[26px] mx-auto text-stone" }
const _hoisted_3 = { class: "text-center font-serif mb-[40px] sm:mb-60px text-headingXl sm:text-heading1xl" }
const _hoisted_4 = { class: "text-bodyLg py-3" }
const _hoisted_5 = { class: "text-bodyLg py-3" }

import { computed, ref, reactive, onUpdated } from 'vue'
import ExitIcon from '@/assets/svg/ExitIcon.vue'
import { useSettingsStore } from '@/store/settings'
import { useEventBus, useStorage } from '@vueuse/core'
import { useLanguageStore } from '@/store/language'
import useLanguage from '@/composables/useLanguage'
import SettingsRow from './SettingsRow.vue'
import ToggleSwitch from './ToggleSwitch.vue'
import DropdownMenu from './DropdownMenu.vue'

interface Props {
  isOpen: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsScreen',
  props: {
    isOpen: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isOpen: boolean
}


const settingsStore = useSettingsStore()
const settingsOpenedBus = useEventBus('settings-opened')
const settingsClosedBus = useEventBus('settings-closed')
const settingsText = useLanguage('settings')
const languageStore = useLanguageStore()
const settingsScreen = ref(null)
let firstButton
let lastButton
let lastActiveElement
let motionSettingTimer
const state = reactive({
  prefersReducedMotion: matchMedia('(prefers-reduced-motion)').matches,
  isDisplayed: false,
})
const keyCodes = {
  ESC: 27,
}

const globalEscape = (e) => {
  var keyCode = e.keyCode || e.which

  switch (keyCode) {
    case keyCodes.ESC:
      e.preventDefault()
      closeSettings()
      break

    default:
      break
  }
}

settingsOpenedBus.on(() => {
  state.prefersReducedMotion = matchMedia('(prefers-reduced-motion)').matches
  lastActiveElement = document.activeElement
  firstButton = document.getElementById('high-contrast-switch')
  lastButton = document.getElementById('close-settings-control')
  firstButton.focus()
  if (settingsScreen.value) {
    trapFocus()
  }
  document.addEventListener('keydown', globalEscape, false)
})

settingsClosedBus.on(() => {
  untrapFocus()
})

const closeSettings = () => {
  settingsClosedBus.emit()
  document.removeEventListener('keydown', globalEscape)
}

const languageIndex = computed(() => {
  let index = 0
  let currentLanguage = useStorage('language', 'english')
  for (let i = 0; i < settingsText.value.languages.length; i++) {
    if (currentLanguage.value == settingsText.value.languages[i].value) {
      index = i
    }
  }
  return index
})

const handleLanguageChange = (index) => {
  languageStore.setLanguage(settingsText.value.languages[index].value)
}

const trapFocus = () => {
  if (settingsScreen.value) {
    ;(settingsScreen.value as HTMLElement).addEventListener(
      'keydown',
      handleKey
    )
  }
}

const handleKey = (e) => {
  var KEYCODE_TAB = 9
  var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB

  if (!isTabPressed) {
    return
  }

  if (e.shiftKey) {
    /* shift + tab */ if (document.activeElement === firstButton) {
      ;(lastButton as unknown as HTMLButtonElement).focus()
      e.preventDefault()
    }
  } /* tab */ else {
    if (document.activeElement === lastButton) {
      ;(firstButton as unknown as HTMLButtonElement).focus()
      e.preventDefault()
    }
  }
}

const untrapFocus = () => {
  if (settingsScreen.value) {
    ;(settingsScreen.value as HTMLElement).removeEventListener(
      'keydown',
      handleKey
    )
  }
  lastActiveElement.focus()
}

onUpdated(() => {
  if (props.isOpen) {
    state.isDisplayed = true
    if (!motionSettingTimer) {
      // poll to see if motion settings have changed
      motionSettingTimer = setInterval(() => {
        state.prefersReducedMotion = matchMedia(
          '(prefers-reduced-motion)'
        ).matches
      }, 2000)
    }
  } else {
    clearInterval(motionSettingTimer)
    motionSettingTimer = null
    setTimeout(() => {
      state.isDisplayed = false
    }, 250)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "settings-screen",
    ref_key: "settingsScreen",
    ref: settingsScreen,
    class: _normalizeClass(["absolute flex items-center left-0 top-0 w-full h-full bg-slateGray", {
      'opacity-0': !props.isOpen,
      'opacity-100': props.isOpen,
      'pointer-events-none': !props.isOpen,
      'pointer-events-auto': props.isOpen,
      invisible: !state.isDisplayed,
    }])
  }, [
    _createElementVNode("button", {
      id: "close-settings-control",
      onClick: closeSettings,
      class: "absolute top-5 right-5 sm:right-50px sm:top-50px cursor-pointer",
      tabindex: props.isOpen ? 520 : -1
    }, [
      _createVNode(ExitIcon, { class: "w-5 h-5" })
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(settingsText).title), 1),
      _createVNode(SettingsRow, null, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(settingsText).language), 1)
        ]),
        control: _withCtx(() => [
          _createVNode(DropdownMenu, {
            id: "language-menu",
            items: _unref(settingsText).languages,
            selectedIndex: _unref(languageIndex),
            tabindex: props.isOpen ? 511 : -1,
            onChange: handleLanguageChange
          }, null, 8, ["items", "selectedIndex", "tabindex"])
        ]),
        _: 1
      }),
      _createVNode(SettingsRow, null, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(settingsText).highContrast), 1)
        ]),
        control: _withCtx(() => [
          _createVNode(ToggleSwitch, {
            id: "high-contrast-switch",
            onClick: _unref(settingsStore).toggleHighContrast,
            active: _unref(settingsStore).highContrast,
            tabindex: props.isOpen ? 510 : -1
          }, null, 8, ["onClick", "active", "tabindex"])
        ]),
        _: 1
      }),
      _createVNode(SettingsRow, null, {
        label: _withCtx(() => [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(settingsText).fontSize), 1)
        ]),
        _: 1
      }),
      _createVNode(SettingsRow, null, {
        label: _withCtx(() => [
          _createElementVNode("p", _hoisted_5, _toDisplayString(state.prefersReducedMotion
                ? _unref(settingsText).motionReduced
                : _unref(settingsText).motionNotReduced), 1)
        ]),
        _: 1
      })
    ])
  ], 2))
}
}

})